import { Component, ViewEncapsulation, Input, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { isEmpty, isUndefined } from 'lodash';
import { fromEvent } from 'rxjs';
import { StoreService } from 'src/app/Services/store';
@Component({
	selector: 'tooltip-handler',
	encapsulation: ViewEncapsulation.None,
	templateUrl: './tooltip-handler.html',
	styleUrls: ['./tooltip-handler.scss'],
})
export class TooltipHandlerComponent implements OnInit {
	@Input() modal;
	@Input() closeModal;
	@Input() modalRef;
	phoneNumber: string;
	content: string;
	showMoreButton: boolean;
	@ViewChild('tooltipContent', { static: true, read: ElementRef })
	tooltipContent: ElementRef;
	showPhoneNumber: boolean;
	tooltipTitle: boolean;
	modalContent: HTMLElement;
	modalContainer: HTMLElement;

	constructor(private el: ElementRef, private storeService: StoreService) {}

	ngOnInit(): void {
		const globalAttributes = this.storeService.getGlobalAttributes();

		if (this.modal.data.tooltip) {
			this.content = this.modal.data.tooltip.expandedContent || this.modal.data.tooltip.content;
			this.showMoreButton = false;
			this.phoneNumber = isEmpty(this.modal.data.phoneNumber) ? '844-416-5371' : this.modal.data.phoneNumber;

			this.showPhoneNumber = this.modal.data.showPhoneNumber;
			if (globalAttributes && !isUndefined(globalAttributes['fl-phone-removal'])) {
				this.showPhoneNumber = !globalAttributes['fl-phone-removal'];
			}
			this.tooltipTitle = this.modal.data.tooltip.title;
			this.setContentHeight();
		}
		// Orientation of tooltip
		const orientationChange = fromEvent(window, 'orientationchange');
		orientationChange.subscribe(() => {
			if (window.orientation === 90) {
				this.closetoolTip();
			}
		});
	}

	setContentHeight() {
		setTimeout(() => {
			const bodyRect = document.body.getBoundingClientRect();
			this.modalContent = document.getElementsByClassName('modal-content')[0] as HTMLElement;
			this.modalContainer = document.getElementsByClassName('modal-container')[0] as HTMLElement;

			const percentageHeight = (this.modalContainer.offsetHeight / bodyRect.height) * 100;
			const tooltipContent = this.el.nativeElement.querySelector('.tooltip-content');

			if (percentageHeight > 79 && tooltipContent) {
				tooltipContent.style.height = '80vh';
			}

			const modalContainerHeight = this.modalContainer.getBoundingClientRect().height;
			this.zeroHeightElem(this.modalContainer);

			// handle modal open animation
			setTimeout(() => {
				this.modalContent.style.height = `${modalContainerHeight + 50}px`;
				setTimeout(() => {
					this.showElem(this.modalContainer);
					this.fadeInElem(this.modalContainer);
					this.modalContainer.style.height = `${modalContainerHeight}px`;
				}, 200);
			}, 1);

			// handle close modal
			const dialogElem = document.getElementsByClassName('modal-dialog')[0];
			(dialogElem as any).onclick = (target) => {
				if (
					target.srcElement.className === 'got-it' || // handle close modal when clicking on got it button
					target.srcElement.className === 'modal-dialog' // handle Close modal when clicking outside
				) {
					this.closetoolTip();
				}
			};
		}, 0);
	}

	getLabel(value) {
		return `Help_${this.modal.data.title + value}`;
	}

	// handle modal close animation
	closetoolTip() {
		this.fadeOutElem(this.modalContainer);
		this.modalContainer.style.height = '50px';
		this.zeroHeightElem(this.modalContent);
		setTimeout(() => {
			this.closeModal();
		}, 400);
	}

	showMore() {
		this.showMoreButton = false;
		this.content = this.modal.data.tooltip.expandedContent;
	}

	hideElem(elem: HTMLElement) {
		elem.classList.add('hidden');
	}

	zeroHeightElem(elem: HTMLElement) {
		elem.classList.add('zero-height');
	}

	showElem(elem: HTMLElement) {
		elem.classList.remove('hidden');
	}

	autoHeightElem(elem: HTMLElement) {
		elem.classList.remove('zero-height');
	}

	fadeOutElem(elem: HTMLElement) {
		elem.classList.add('fadeOut');
	}

	fadeInElem(elem: HTMLElement) {
		elem.classList.add('fadeIn');
	}
}
